import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export enum CalDriftWarningResult {
  Continue = 'continue',
  Void = 'void',
}

export interface ICalDriftWarningData {
  calVariabilityPercent: number;
  maxCalDriftPercent: number;
}

@Component({
  standalone: false,
  selector: 'app-cal-drift-warning-dialog',
  templateUrl: './cal-drift-warning-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./../../shared/form/form.component.scss']
})
export class CalDriftWarningDialogComponent {
  readonly calDriftWarningResult = CalDriftWarningResult;

  constructor(public dialogRef: MatDialogRef<CalDriftWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICalDriftWarningData) {
  }

  onContinue(): void {
    this.dialogRef.close(CalDriftWarningResult.Continue);
  }

  onVoid(): void {
    this.dialogRef.close(CalDriftWarningResult.Void);
  }
}
